(function() {
    'use strict';
 
 
a3_pilot_reports.factory('PilotReportSendToServerFactory',PilotReportSendToServerFactory);
    
    /**
    * @memberof PilotReports
    * @ngdoc factory
    * @name PilotReportSendToServerFactory
    * @description 
    *   Transform Pilot Reports in order to send them to the server
    * @ngInject
    */
function PilotReportSendToServerFactory($log){

        /**
        * Initialize the PilotReportSendToServer
        * @memberof PilotReportSendToServerFactory
        */
		function PilotReportSendToServer() {
			this.Created = null;
			this.LastUpdated = null;		
			this.FlightAimsId = null;
			this.FlightId = null;
			this.FlightDate = null;
			this.FlightNo = null;
			this.Departure = null;
			this.Arrival = null;
			this.ReportGuid = null;
			this.AuthorCrewId = null;
			this.AuthorCrewAimsId = null;
			this.Items = [];
			this.Autoland = 'manual';
			this.AutolandWorkOrderNo = null;
			this.ArrivalGroundServices = [];
			this.DepartureGroundServices = [];
			this.AutolandReason = null;
			this.ManualLandingComments = null;
		}
    
        /**
        * Initialize the PilotReportSendToServerItem
        * @memberof PilotReportSendToServerFactory
        */
        function PilotReportSendToServerItem() {
			this.ReportGuid = null;
			this.TemplateItemId = null;
			this.Value = 0;
			this.Remarks = '';
			this.DelayMinutes = null;
		}


		var service = {
			getCompletedListFromPilotReportLocalEdits : getCompletedListFromPilotReportLocalEdits
		}    
	
        /**
         * Transform all cabin local reports in order to be sent to the server
         * @memberof PilotReportSendToServerFactory
         * @param {Array} pilotReportLocalEdits
         * @returns {Array} PilotReportsSendToServer 
         */
		function getCompletedListFromPilotReportLocalEdits(pilotReportLocalEdits){
			var result = [];
			
			if (pilotReportLocalEdits == null)
				return result;
			
			var arrayLength = pilotReportLocalEdits.length;
			for (var i = 0; i < arrayLength; i++) {
				if (pilotReportLocalEdits[i].Status === 'completed')
				{
					result.push(getReportFromPilotReportLocalEdit(pilotReportLocalEdits[i]));
				}
			}

            //Temporary: fix: Ground Services:  Used values (true/false) from local storage.
             var resultChecked = fixUsedValueLS(result);

            return resultChecked;
        }

        //Temporary: fix - Ground Services - local storage from true/false values. (int Used: 0:false, 1:true, 2:inop) 
        function fixUsedValueLS(cabinReportLocalEdits){
            for (var i = 0; i < cabinReportLocalEdits.length; i++) {
                if(cabinReportLocalEdits[i].DepartureGroundServices.length > 0){
                    for(var j = 0; j < cabinReportLocalEdits[i].DepartureGroundServices.length; j++){
                        if (cabinReportLocalEdits[i].DepartureGroundServices[j]){
                            if (cabinReportLocalEdits[i].DepartureGroundServices[j].Used === true) {
                                cabinReportLocalEdits[i].DepartureGroundServices[j].Used = 1;
                            }else if (cabinReportLocalEdits[i].DepartureGroundServices[j].Used === false){
                                cabinReportLocalEdits[i].DepartureGroundServices[j].Used = 0;
                            }
                        }
                    }
                }
            }
            return cabinReportLocalEdits;
        }



		
         /**
         * Transform a pilot local reports in order to be sent to the server
         * @memberof PilotReportSendToServerFactory
         * @param {object} pilotReportLocalEdit
         * @returns {object} PilotReportSendToServer 
         */
		function getReportFromPilotReportLocalEdit(pilotReportLocalEdit){
			var result = new PilotReportSendToServer();
			
			result.Created = pilotReportLocalEdit.Created;
			result.LastUpdated = pilotReportLocalEdit.LastUpdated;		
			result.FlightAimsId = pilotReportLocalEdit.FlightAimsId;
			result.FlightId = pilotReportLocalEdit.FlightId;
			result.FlightDate = pilotReportLocalEdit.FlightDate;
			result.FlightNo = pilotReportLocalEdit.FlightNo;
			result.Departure = pilotReportLocalEdit.Departure;
			result.Arrival = pilotReportLocalEdit.Arrival;
			result.ReportGuid = pilotReportLocalEdit.ReportGuid;
			result.AuthorCrewId = pilotReportLocalEdit.AuthorId;
			result.AuthorCrewAimsId = pilotReportLocalEdit.AuthorAimsId;
			result.Items = new Array();
			//result.ArrivalGroundServices = pilotReportLocalEdit.ArrivalGroundServices;
			result.DepartureGroundServices = pilotReportLocalEdit.DepartureGroundServices;

			result.ACUProvisionValue = pilotReportLocalEdit.ACUProvision.value;
			result.ACUProvisionRemarks =  pilotReportLocalEdit.ACUProvision.remarks;
			result.ACUProvisionDelayMinutes =  pilotReportLocalEdit.ACUProvision.delayMinutes;
            
            if(pilotReportLocalEdit.AutolandSatisfactory){
                result.Autoland = 'AutolandSatisfactory';
            }else if(pilotReportLocalEdit.AutolandUnsatisfactory){
                result.Autoland = 'AutolandUnsatisfactory';
				result.AutolandWorkOrderNo = pilotReportLocalEdit.AutolandWorkOrderNo;
            }else if(pilotReportLocalEdit.ManualLanding){
				result.Autoland = 'ManualLanding';
				result.ManualLandingComments = pilotReportLocalEdit.ManualLandingComments;
			}
			else if(pilotReportLocalEdit.catApproachUnsatisfactory){
                result.Autoland = 'CATApproachUnsatisfactory';
            }else if(pilotReportLocalEdit.catApproachSatisfactory){
                result.Autoland = 'CATApproachSatisfactory';
            }

			if(pilotReportLocalEdit.AutolandReasonIsLowVisibility){
				result.AutolandReason = 'LVP in Force';
			}else if(pilotReportLocalEdit.AutolandReasonIsPractice){
				result.AutolandReason = 'Practice Autoland';
			}
			

			var sectionCount = pilotReportLocalEdit.Sections.length;
			for (var i = 0; i < sectionCount; i++) {
				
				var itemCount = pilotReportLocalEdit.Sections[i].Items.length;
				for (var j = 0; j < itemCount; j++) {
					
					var newItem = new PilotReportSendToServerItem();
					newItem.ReportGuid = pilotReportLocalEdit.ReportGuid;
					newItem.TemplateItemId = pilotReportLocalEdit.Sections[i].Items[j].Id;
					newItem.Value = pilotReportLocalEdit.Sections[i].Items[j].ItemHasValue ? 1 : 0;
					if (newItem.Value == 1){
						newItem.Remarks = pilotReportLocalEdit.Sections[i].Items[j].ItemValue;
					}
					newItem.DelayMinutes = pilotReportLocalEdit.Sections[i].Items[j].DelayMinutes;

					result.Items.push(newItem);
				}

			}		

			return result;
		}
	
		return service;
	}

 })();   